import React, { useEffect, useState } from 'react';
import { getCashInvoiceList, SearchInvoice, ShowInvocieApi } from './ApiMethods';
import '../../Beneficiary/styles/BeneficiaryList.css';
import CustomPagination from './CustomPagination';
import { useNavigate } from 'react-router-dom';
import AppLoader from '../../../components/AppLoader';
import { FaSearch } from 'react-icons/fa';
import { Tooltip } from '@mui/material';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import toast from 'react-hot-toast';
import InvoiceFilters from './InvoiceFilters';
import InvoiceSummary from './InvoiceSummary';

export function formatCustomDate(isoDate) {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export const formatDate = dateString => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedHours = String(hours % 12 || 12).padStart(2, '0');

  return `${year}-${month}-${day} ${formattedHours}:${minutes} ${ampm}`;
};

const tableHeaders = [
  { name: 'Invoice Number' },
  { name: 'Date' },
  { name: 'Patient Name' },
  { name: 'Patient Amount' },
  { name: 'Patient VAT' },
  { name: 'Patient Paid Amount' },
  { name: 'File Number' },
  { name: 'Nationality' },
  { name: 'Description' },
  { name: 'Actions' }
];

export default function CashTable() {
  const navigate = useNavigate();
  const [invoiceList, setInvoiceList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({
    branch_id: '',
    customer_id: 0,
    customer_name: '',
    end_date: '',
    invoice_type: 'sales',
    page: 1,
    payment_method: '',
    per_page: 10,
    start_date: ''
  });

  useEffect(() => {
    getCashInvoiceList(setLoading, setInvoiceList, payload);
  }, [payload?.page, payload.per_page]);

  const onPageChange = (newPage, newRowsPerPage) => {
    setPayload(prev => ({
      ...prev,
      page: newPage,
      per_page: newRowsPerPage
    }));
  };

  const handelShowClick = data => {
    ShowInvocieApi(setLoading, data?.id).then(response => {
      if (response?.status === 200) {
        navigate('/receptionist/show-invoice', {
          state: { data: response?.data }
        });
      }
    });
  };

  return (
    <>
      <InvoiceFilters
        type='sales'
        filters={payload}
        setFilters={setPayload}
        setInvoiceList={setInvoiceList}
        setLoading={setLoading}
      />
      <div className='overflow-x-auto'>
        <div className='super-git-table !p-0 !m-0'>
          <table className='table-super-git !p-0'>
            <thead className='!p-0'>
              <tr className='!p-0'>
                {tableHeaders.map((el, index) => {
                  return (
                    <th className='!p-2 !text-sm !bg-[#373d45]' key={'tableHeaders_' + index}>
                      {el.name}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {invoiceList?.data?.length > 0 ? (
                invoiceList.data.map((el, index) => (
                  <tr key={'invoiceData_' + index} className='!p-0'>
                    <td className='!p-1 !text-sm'>{el?.invoice_number}</td>
                    <td className='!p-1 !text-sm'>{formatDate(el?.date)}</td>
                    <td className='!p-1 !text-sm capitalize text-start'>{el?.customer_name}</td>
                    <td className='!p-1 !text-sm'>
                      {el?.patient_share % 1 !== 0 ? el.patient_share.toFixed(2) : el?.patient_share}
                    </td>
                    <td className='!p-1 !text-sm'>
                      {el?.patient_tax % 1 !== 0 ? el.patient_tax.toFixed(2) : el?.patient_tax}
                    </td>
                    <td className='!p-1 !text-sm'>{el?.amount % 1 !== 0 ? el.amount.toFixed(2) : el?.amount}</td>
                    <td className='!p-1 !text-sm'>{el?.file_number}</td>
                    <td className='!p-1 !text-sm'>{el?.nationality}</td>
                    <td className='!p-1 !text-sm'>{el?.description}</td>
                    <td className='flex gap-2 justify-center items-center mx-2 my-auto !mt-2 !p-1'>
                      <Tooltip title='View'>
                        <div onClick={() => handelShowClick(el)} className='text-xl cursor-pointer text-green-500'>
                          <MdOutlineRemoveRedEye />
                        </div>
                      </Tooltip>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length} className='px-4 py-2 text-center text-sm text-gray-700'>
                    No invoices found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <CustomPagination
          currentPage={invoiceList?.page || 1}
          rowsPerPage={invoiceList?.per_page || 5}
          totalRecords={invoiceList?.total_record || 0}
          onPageChange={onPageChange}
        />
        <InvoiceSummary filtersDetails={invoiceList} loading={loading} />
        <AppLoader showLoader={loading} setShowLoader={setLoading} />
      </div>
    </>
  );
}
